import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Input, Select } from 'antd';

import { INPUT_TYPES } from '../../constants/componentTypes';

import { getPlatformClassName } from '../../helpers';

import { BRImages } from '../../assets/imgs';
import '../../assets/scss/index.scss';


const { TextArea } = Input;

const CustomInput = ({
  type = INPUT_TYPES.TEXT,
  name,
  placeholder,
  rows = 4,
  className = '',
  iconRender,
  value,
  onChange,
  options,
  showPasswordIcon = BRImages.CommonImages.ShowPassword,
  hidePasswordIcon = BRImages.CommonImages.HidePassword,
  disabled = false,
  searchable = false,
  ...props
}) => {
  const inputClass = classNames('custom-input shadow-none radius-2 manrope-14-regular w-100 px-16', className);
  const selectClass = classNames('custom-input shadow-none custom-select radius-2 manrope-14-regular w-100 py-12',className);

  const renderPasswordIcon = (visible) => (
    <img
      src={visible ? showPasswordIcon : hidePasswordIcon}
      className='eyeIcon cursor-pointer'
      alt='password visibility toggle'
    />
  );

  switch (type) {
    case INPUT_TYPES.TEXT_AREA:
      return (
        <TextArea
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          rows={rows}
          className={inputClass}
          disabled={disabled}
          {...props}
        />
      );
    case INPUT_TYPES.PASSWORD:
      return (
        <Input.Password
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          iconRender={(visible) => renderPasswordIcon(visible)}
          className={inputClass}
          disabled={disabled}
          {...props}
        />
      );
    case INPUT_TYPES.SELECT:
      return (
        <Select
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={selectClass}
          options={options}
          disabled={disabled}
          filterOption={
            searchable
              ? (input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              : undefined
          }
          getPopupContainer={(trigger) => trigger.parentNode}
          showSearch={searchable}
          dropdownMatchSelectWidth={false}
          {...props}
          suffixIcon={
            <img src={BRImages.CommonImages.DropdownIconGray} alt='dropdown-icon' width='12px' />
          }
        />
      );
    default:
      return (
        <Input
          name={name}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
          className={inputClass}
          {...props}
        />
      );
  }
};

CustomInput.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  maxField: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  showPasswordIcon: PropTypes.string,
  hidePasswordIcon: PropTypes.string,
  disabled: PropTypes.bool
};

export default memo(CustomInput);
